import { Hold, Promotion } from "webshop-api";
import { ArrayHelper } from "webshop-modules/helper/Array.helper";

/**
 * HoldMaximumAmountProvider
 */
export class HoldMaximumAmountProvider {

    /**
     * whatItDoes
     * provides maximum amount of available tickets for provided hold with optional promotion configuration
     */
    public static getMaximumFor(hold: Hold, applicationMaximum: number, promotion?: Promotion): number {
        const maximum = [ applicationMaximum ];

        maximum.push(hold.totalFreeSeats ? hold.totalFreeSeats : 0);
        maximum.push(hold.maxFreeConnectedSeats ? hold.maxFreeConnectedSeats : 0);

        if (promotion && promotion.maxTicketsPerCode) {
            maximum.push(promotion.maxTicketsPerCode);
        }

        if (promotion && promotion.maxTicketsPerEvent) {
            maximum.push(promotion.maxTicketsPerEvent);
        }

        if (promotion && promotion.maxTicketsPerOrder) {
            maximum.push(promotion.maxTicketsPerOrder);
        }

        if (
            promotion &&
            promotion.totalNumbersOfTickets !== undefined &&
            promotion.soldNumbersOfTickets !== undefined
        ) {
            maximum.push(promotion.totalNumbersOfTickets - promotion.soldNumbersOfTickets);
        }

        return maximum.reduce(ArrayHelper.ToLowestValue, Number.MAX_SAFE_INTEGER);

    }

}
